import { get } from 'lodash';
import { call, put, select } from 'redux-saga/effects';
import queryString from 'query-string';
import { API } from '../../api';
import { getLayers } from '../components/selectors';

const getServerConfig = ({ serverConfig }) => serverConfig;
const getMapHoverProps = ({ mapHoverProps }) => mapHoverProps;
const getMapHoverFilters = ({ mapHoverFilters }) => mapHoverFilters;
const getColumns = ({ reports }) => get(
    reports.find(({ id }) => id === 'PARCEL_REPORT'),
    'sections.[0].properties',
    [],
  )
    .filter(({ column }) => !!column)
    .reduce((acc, prop) => {
      if (prop.source) {
        acc[`${prop.source}:${prop.column}`] = prop;
      } else {
        acc[prop.column] = prop;
      }
      return acc;
    }, {});

export function* fetchHoveredParcelByCoords(action) {
  const { lat, lng } = get(action, 'payload.lngLat', {});

  const mapHoverProps = yield select(getMapHoverProps);
  const layers = yield select(getLayers);
  const columns = yield select(getColumns);

  const defaultProps = mapHoverProps.length
    ? mapHoverProps
    : ['parcel_id', 'add_combo', 'owner_name'];

  const selectedLayerProps = Object.values(layers)
    .map(({ source, dataKey, preventFiltering }) => {
      if (preventFiltering) return null;
      return source ? `${source}:${dataKey}` : dataKey;
    })
    .filter(Boolean);

  const serverConfig = yield select(getServerConfig);
  const mapHoverFilters = yield select(getMapHoverFilters);

  const props = Array.from(
    new Set(
      [...defaultProps, ...selectedLayerProps].filter((key) => columns[key]),
    ),
  );

  const query = {
    latlng: `${lat},${lng}`,
    props: props.join(','),
    ...mapHoverFilters,
  };

  const path = `/parcel/${serverConfig.namespace}/coord?${queryString.stringify(
    query,
  )}`;

  const results = yield call(API, 'get', 'api', path);

  const hasResults = get(results, 'parcels.length');

  if (!hasResults) {
    yield put({
      type: 'CLEAR_HOVERED_PARCEL',
    });
    return;
  }

  const parcelResult = results.parcels[0];
  yield put({
    type: 'SET_HOVERED_PARCEL',
    payload: {
      parcel: parcelResult,
      displayParcel: Object.keys(parcelResult).reduce((acc, key) => {
        const newKey = (columns[key] || {}).label || key;
        acc[newKey] = parcelResult[key];
        return acc;
      }, {}),
    },
  });
}
